var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "mb-5" },
    [
      _c(
        "FormulateForm",
        {
          ref: "taxConfigurationGroupForm",
          attrs: { name: "taxConfigurationGroupForm" },
          on: { submit: _vm.save },
        },
        [
          _c(
            "b-card-actions",
            {
              attrs: {
                "action-collapse": "",
                title: _vm.$t("Informações Gerais"),
                "show-loading": _vm.isLoading,
              },
            },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c("FormulateInput", {
                        staticClass: "required",
                        attrs: {
                          id: "tax-configuration-group-name",
                          name: "name",
                          type: _vm.isEdit ? "label" : "text",
                          label: _vm.$t("Nome"),
                          instruction: _vm.$t(
                            "É por este nome que a exceção é associada ao produto"
                          ),
                          validation: "required",
                        },
                        model: {
                          value: _vm.form.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "name", $$v)
                          },
                          expression: "form.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "tax-configuration-group-ncm",
                          name: "ncm",
                          type: _vm.isEdit ? "label" : "select-searchable",
                          label: _vm.$t("NCM"),
                          placeholder: _vm.$t("Todos os NCMs"),
                          instruction: _vm.$t(
                            "Quando informado, na associação com o produto este cadastro só aparecerá se for deste NCM"
                          ),
                          options: _vm.getComboNcms,
                        },
                        on: { fetchSearch: _vm.ncmSearch },
                        model: {
                          value: _vm.form.ncm,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "ncm", $$v)
                          },
                          expression: "form.ncm",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "tax-configuration-group-active",
                          name: "active",
                          type: "switch",
                          label: _vm.$t("Ativo"),
                          disabled: _vm.isInUse,
                          instruction: _vm.isInUse
                            ? _vm.$t(
                                "Não é possível inativar: existem produtos associados a este cadastro. Remova a associação pela ação 'Associar produtos' na listagem de Exceções Fiscais."
                              )
                            : "",
                        },
                        model: {
                          value: _vm.form.active,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "active", $$v)
                          },
                          expression: "form.active",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "tax-configuration-group-description",
                          name: "description",
                          type: "textarea",
                          rows: "2",
                          label: _vm.$t("Descrição"),
                        },
                        model: {
                          value: _vm.form.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "description", $$v)
                          },
                          expression: "form.description",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-card-actions",
            {
              attrs: {
                "action-collapse": "",
                title: _vm.$t(
                  "Tributos da reforma (CBS/IBS e Imposto Seletivo)"
                ),
                "show-loading": _vm.isLoading,
              },
            },
            [
              _c("tax-configuration-group-tax-reform-form", {
                attrs: { busy: _vm.isLoading },
              }),
            ],
            1
          ),
          _c(
            "b-card-actions",
            {
              attrs: {
                "action-collapse": "",
                title: _vm.$t("Exceções fiscais por UF"),
                "show-loading": _vm.isLoading,
              },
            },
            [
              _c("tax-configuration-group-item-table", {
                on: {
                  "add-item": function ($event) {
                    return _vm.openItemSidebar()
                  },
                  "update-item": _vm.openItemSidebar,
                  "delete-item": _vm.deleteItem,
                },
              }),
              _c("tax-configuration-group-item-sidebar", {
                ref: "itemSidebar",
                on: { create: _vm.addItem, update: _vm.updateItem },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("e-crud-actions", {
        attrs: { busy: _vm.isLoading },
        on: { save: _vm.save, cancel: _vm.cancel },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }